<template>
  <mdb-container class="gp-has-header">

    <div v-if="fromPub">
      <mdb-btn @click="pubHome" icon="home">Back</mdb-btn>
    </div>
    <h2 class="h1-responsive font-weight-bold text-center my-5">Features</h2>
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">

            <img class="img-fluid" :src="settings.staticImageUrl + '/features/demo-home-page.png'" alt="Group's Home Image" />

          <a :href="settings.staticImageUrl + '/features/demo-home-page.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Custom Group Home Page</strong>
        </h3>
        <p class="dark-grey-text">You can lay out your home page with many sections in a way that reflects your group's own personality.
          Creating pages features an editor that gives you rich text, including bold, italics, font size and, of course, images.
          Animated GIFs? Go ahead. It's not recommended, but go ahead. Embed a video? Sure!</p>
        <p>
          Want to see a group in action? <router-link to="/group/demo">Visit the demo group </router-link>.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">

          <img class="img-fluid" :src="settings.staticImageUrl + '/features/event-detail.png'" alt="Event Details Image" />

          <a :href="settings.staticImageUrl + '/features/event-detail.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Event Creation</strong>
        </h3>
        <p class="dark-grey-text">
          Set up inviting events with clear details. It's up to you how to communicate the event's location.
          You can include a link to the precise location using Google maps, or any other website that will help your people find you.
        </p>

      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/event-privacy.png'" alt="Event Privacy Image" />
          <a :href="settings.staticImageUrl + '/features/event-privacy.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Event Privacy</strong>
        </h3>
        <p class="dark-grey-text">
          If you run a group that is publicly visible, you can fine tune the settings on each event to control
          who sees what.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/event-settings.png'" alt="Event Settings Image" />
          <a :href="settings.staticImageUrl + '/features/event-settings.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Event Settings</strong>
        </h3>
        <p class="dark-grey-text">
          Each event has its own settings to control how reservations and waitlists work.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/event-questions.png'" alt="Event Privacy Image" />
          <a :href="settings.staticImageUrl + '/features/event-questions.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Event Questions</strong>
        </h3>
        <p class="dark-grey-text">
          Need to ask questions when a member reserves a spot? You can ask multiple questions, make them required or
          optional, and control who sees the answers.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/settings.png'" alt="Group Settings Image" />
          <a :href="settings.staticImageUrl + '/features/settings.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Your Group. Your Rules.</strong>
        </h3>

        <p class="dark-grey-text">
            Public or private group? (Private means <i>private</i>. Organizers must share a secret URL
              for members to find the group.
        </p>
        <p class="dark-grey-text">
          Require a photo for a person to join.
        </p>

        <p class="dark-grey-text">
          Want to vet members before letting them in? No problem.
        </p>

      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/attendance-taking.png'" alt="Attendance Image" />
          <a :href="settings.staticImageUrl + '/features/attendance-taking.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Attendance Taking</strong>
        </h3>

        <p class="dark-grey-text">
          Many groups have attendance policies for many reasons. You have the ability to take attendance at events, and yes, mark no-shows.
        </p>
        <p class="dark-grey-text">
          Attendance taking is available starting 15 minutes prior to the event's scheduled start time.
        </p>

        <p class="dark-grey-text">
          Attendance not important to your group? No worries. You don't have to.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/rsvp_simple.png'" alt="Simple RSVP" />
          <a :href="settings.staticImageUrl + '/features/rsvp_simple.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Simple RSVPs</strong>
        </h3>

        <p class="dark-grey-text">
          On each event, you may choose to keep it simple and only ask for a guest count (or not even allow guests!)
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/rsvp_advanced.png'" alt="Advanced RSVP" />
          <a :href="settings.staticImageUrl + '/features/rsvp_advanced.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Advanced RSVPs</strong>
        </h3>

        <p class="dark-grey-text">
          On the other hand, you might need to have a breakdown of the types of attendees, e.g., number of adults, children, seniors, etc.
        </p>
        <p class="dark-grey-text">
          You might also need to ask questions about the event. Questions can be yes/no, short answer or long answer.
          You can require certain questions and make others optional. You can also determine whether each question is visible to other members,
          or just to the organizer.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/custom-fields.png'" alt="Custom Fields" />
          <a :href="settings.staticImageUrl + '/features/custom-fields.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Custom Fields</strong>
        </h3>

        <p class="dark-grey-text">
          Your group is unique. So are your members. You can create custom fields to help track and organize your membership better.
        </p>
        <p class="dark-grey-text">
          Of course, you can download your member information with your custom fields!
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/document-library.png'" alt="Document Library" />
          <a :href="settings.staticImageUrl + '/features/document-library.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Document Library</strong>
        </h3>

        <p class="dark-grey-text">
          Got rules and regulations? Disclaimers? Detailed instructions?
        </p>
        <p class="dark-grey-text">
          You may put document text or links to the information on your home page and  individual events.
        </p>
        <p class="dark-grey-text">
          Create documents to convey this information to your members.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/member-dashboard.png'" alt="Member Dashboard" />
          <a :href="settings.staticImageUrl + '/features/member-dashboard.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Member Dashboard</strong>
        </h3>

        <p class="dark-grey-text">
          See your membership at a glance and drill into details about individual members.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/payment_tracking.png'" alt="Payment Tracking" />
          <a :href="settings.staticImageUrl + '/features/payment_tracking.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Payment Tracking</strong>
        </h3>

        <p class="dark-grey-text">
          If you need to track dues or other forms of payments, {{settings.siteName}} has tools to help you manage your members.
        </p>
        <p class="dark-grey-text">
          You may define subscription plans and charge your members for their participation.
          You may either record payments manually, or you may accept credit cards from your members. To accept credit cards, you need to have an account with Stripe.
          Once your Stripe account is set up, you can supply a restricted credential to allow {{settings.siteName}} to make charges on your behalf.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/financial-summary.png'" alt="Financial Summary" />
          <a :href="settings.staticImageUrl + '/features/financial-summary.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Financial Summary</strong>
        </h3>

        <p class="dark-grey-text">
          If you need to track more than dues, you can set up categories and record transactions. You may choose whether to make
          a financial summary available to members.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/comments.png'" alt="Social Features" />
          <a :href="settings.staticImageUrl + '/features/comments.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Social Features</strong>
        </h3>

        <p class="dark-grey-text">
          Comment on events and photos. Like comments and photos.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/gallery.png'" alt="Photo Gallery" />
          <a :href="settings.staticImageUrl + '/features/gallery.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Event Photo Gallery</strong>
        </h3>

        <p class="dark-grey-text">
          Every event has a photo gallery where members may upload photos to share the memories of your event.
        </p>

        <p class="dark-grey-text">
          Organizers may select images from various galleries to be highlighted in a group slide show presented on your
          home page.
        </p>
      </mdb-col>
    </mdb-row>
    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/reputation.png'" alt="Reputation Feature" />
          <a :href="settings.staticImageUrl + '/features/reputation.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Reputation</strong>
        </h3>

        <p class="dark-grey-text">
          Want a fun way to encourage participation and discourage no shows? Use the reputation system. You can define points for attending, hosting and no-showing. You can also control when "ribbons" are awarded as your members' reputation within the group grows.
        </p>
        <p class="dark-grey-text">
          Event and group pages show the ribbon by members' profile pictures so you can see at a glance what each person's reputation is.
        </p>
        <p class="dark-grey-text">
          Don't think this is cool or fun? You can turn the feature off.
        </p>
        <p class="dark-grey-text">
          Don't like the label "reputation"? Call it what you want!  Karma, participation score, street cred.... whatever works for your group's style.
        </p>

      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/activity-feed.png'" alt="Activity Feed" />
          <a :href="settings.staticImageUrl + '/features/activity-feed.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Activity Feed</strong>
        </h3>

        <p class="dark-grey-text">
          You can show an activity feed on your home page so members can see what's been happening.
        </p>
        <p class="dark-grey-text">
          You can choose whether your activity feed is visible to non-members. If you do make it visible, it's a good way for potential members to see how active your group is, or what you've been up to.
        </p>
      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/adhoc-notifications.png'" alt="Sending Messages" />
          <a :href="settings.staticImageUrl + '/features/adhoc-notifications.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Communicate</strong>
        </h3>

        <p class="dark-grey-text">
          Sometimes you need to send a message to all your members, or those attending an event. You can send messages, and pick the audience.
        </p>

      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/tasks.png'" alt="Tasks" />
          <a :href="settings.staticImageUrl + '/features/tasks.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Notifications and Tasks</strong>
        </h3>

        <p class="dark-grey-text">
          You are in control of notifications and other tasks related to your events. Sometimes you need to announce
          an event far in advance. Other times you need to have announcements go out closer to the date. You can
          send reminders to those going, send a different message to those who haven't signed up, etc.
        </p>

      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/stripe.png'" alt="Stripe Integration" />
          <a :href="settings.staticImageUrl + '/features/stripe.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Accept Credit Cards</strong>
        </h3>

        <p class="dark-grey-text">
          You can seamlessly integrate your own Stripe account with {{ settings.siteName }} and accept payments for your events
          and memberships.
        </p>

      </mdb-col>
    </mdb-row>

    <hr class="my-5" />
    <mdb-row>
      <mdb-col lg="5" xl="4">
        <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" :src="settings.staticImageUrl + '/features/forum-access.png'" alt="Forum" />
          <a :href="settings.staticImageUrl + '/features/forum-access.png'" target="_blank">
            <mdb-mask overlay="white-slight" waves/>
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7" xl="8">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>Forum</strong>
        </h3>

        <p class="dark-grey-text">
          Set up forums for various discussions, and control who has access to each forum.
        </p>

      </mdb-col>
    </mdb-row>



    <hr class="my-5" />
    <mdb-btn @click="$router.push('/register')" color="primary" size="md">Get Started</mdb-btn>
    <hr class="my-5" />


  </mdb-container>
</template>

<script>
import groupCard from './group/Card'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbView
} from 'mdbvue';

export default {
    name: 'Explore',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbRow,
      mdbCol,
      mdbMask,
      mdbCardImage,
      mdbView,
      mdbBadge,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      groupCard
    },
    data() {
      return {
        features: [
          { title: "Custom Group Home Page", image: this.settings.staticImageUrl + "/features/demo-home-page.png",
            summary: "Lay out your group's home page to reflect its own personality."},
          { title: "Event Details", image: this.settings.staticImageUrl + "/features/event-detail.png",
            summary: "Set up inviting events with clear details. It's up to you how to communicate the event's location. You can include a link to the precise location using Google maps, or any other website that will help your people find you."}
        ],
        offset: 0,
        totalGroups: 0,
        summaryModal: false,
        currentGroup: null,
        isTyping: false,
        fromPub: false,
        query: ""
      }
    },
    mounted() {
      if (this.$route.query.src == "pub") this.fromPub = true
    },
    computed: {
      settings() {
        return this.$store.state.settings
      }
    },
    methods: {
      pubHome() {
        window.open(this.settings.staticSiteUrl)
      },
      showFeature(feature) {
        this.currentGroup = group
        this.summaryModal = true
      },
    }
  };
</script>
